<template>

  <div :id="random_id"
       v-bind="$attrs"
       :data-testid="dataTestid"
       :class="twMerge('min-w-full' , appendClass)">

  <TsCard appendClass="w-full" :data-testid="dataTestid+'card-vacancies-cards'">
    <TsImage class="w-full h-48 rounded-lg object-cover" :src="image" :data-testid="dataTestid+'-card-vacancies-image'" loading="lazy"/>
    <div class="px-2">
      <p class="text-natural-grey dark:text-gray-400 text-left text-xl font-bold  sm:mt-0 mt-1"
         :data-testid="dataTestid +'-card-vacancies-title'">
        {{title}}
      </p>
      <p class="text-natural-grey dark:text-gray-400 text-left sm:h-auto h-36 md:h-auto sm:mt-3 mt-3"
         v-html="description">
      </p>
    </div>
    <template #footer>
      <div class="h-full bottom-2 sm:px-6 px-2 flex justify-center">
        <TsButton :rounded="true"
                  appendClass="m-auto w-full sm:mb-8 mb-3"
                  @click="emit('buttonClick')"
                  :data-testid="dataTestid+'-card-vacancies-button'"
      :label="buttonLabel"
         />
      </div>
    </template>
  </TsCard>
  </div>
</template>

<script setup lang="ts">
import {useRandomUUID} from "~/composables/useRandomUUID";
import {twMerge} from "tailwind-merge";
import {onMounted , ref} from "vue";

const TsCard = defineAsyncComponent(
    () => import('~/components/organisms/TsCard.vue')
);

type Props = {
  title?: string;
  description?: string;
  image?: string;
  dataTestid?: string,
  buttonLabel?: string;
}

const props = withDefaults(defineProps<Props>(), {
  title: 'Section Name',
  description: 'lorem iosum',
  image: '/images/cardImage.webp',
  buttonLabel:'Visit Section'

});

const random_id = ref('');

const emit = defineEmits(['buttonClick']);

</script>
